import React, { createContext, useContext } from 'react';
import ENVIRONMENTS from 'constants/enviroments';
import { Bus, FerryFill } from 'icons/Location_Transport';

export interface TransportStrategy {
  /** true quando o tipo de transporte é embarcação (navio/ferry) */
  isSea: boolean;
  TransportIcon: React.ComponentType<any>;
  /**
   * Indica se deve exibir o horário de embarque além do horário de saída.
   * Para embarcações, depende do campo `showDepartureTimeOnly` da viagem.
   */
  showBoardingTime: (trip: { showDepartureTimeOnly?: boolean }) => boolean;
  /** Indica se vagas de veículo devem ser exibidas */
  showVehicleCapacity: boolean;
  /** Indica se o mapa de poltronas está disponível para o tipo de transporte */
  hasSeatMap: boolean;
  /** Padding aplicado ao box de horário na listagem de viagens */
  timeDisplayPadding: string;
  /** Opções de ordenação de viagens (somente embarcações têm opção de embarque) */
  orderOptions: Array<{ KEY: string; VALUE: string }>;
}

const shipStrategy: TransportStrategy = {
  isSea: true,
  TransportIcon: FerryFill,
  showBoardingTime: (trip) => !trip.showDepartureTimeOnly,
  showVehicleCapacity: true,
  hasSeatMap: false,
  timeDisplayPadding: '0.5rem',
  orderOptions: [
    { KEY: 'open', VALUE: 'Horário de embarque' },
    { KEY: 'start', VALUE: 'Horário de saída' },
  ],
};

const busStrategy: TransportStrategy = {
  isSea: false,
  TransportIcon: Bus,
  showBoardingTime: () => false,
  showVehicleCapacity: false,
  hasSeatMap: true,
  timeDisplayPadding: '0.5rem',
  orderOptions: [],
};

const TransportContext = createContext<TransportStrategy>(busStrategy);

export const TransportProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const strategy =
    ENVIRONMENTS.TICKET_SALES.ITINERARY_TYPE === 'ship'
      ? shipStrategy
      : busStrategy;

  return (
    <TransportContext.Provider value={strategy}>
      {children}
    </TransportContext.Provider>
  );
};

export const useTransport = (): TransportStrategy =>
  useContext(TransportContext);
